module.exports = __webpack_public_path__ + "fonts/FairwaterScript-Bold.c8bda6c.ttf";